// Used to create request target with optional path paramaters
const createTarget = (target) => {
  return (param) => {
    if (param === undefined) {
      return target;
    }

    if (param === null) {
      return createTarget(target);
    }

    return createTarget(target + `/${param}`);
  }
}

export { createTarget };